// FarmsList.jsx
import React from 'react';
import FarmCard from './FarmCard';

const FarmsList = ({ farms , rootPools}) => {
    // console.log(rootPools, 'rootPools')
    return (
        <div className='parents_cards'>
            {rootPools?.map((farm, index) => (
                <FarmCard key={farm.id || index} farm={farm} />
            ))}
        </div>
    );
};
export default FarmsList;
